import { post, get } from "../../api";

const allProductData = (headers, body) => post("allProductData", headers, body);
const omniFiltersData = (headers, body) =>
  post("omniFiltersData", headers, body);
const getDetails = body => post("details", {}, body);
const listingDetails = body => post("listingDetails", {}, body);

const getShippingDetails = body => post("pincode", {}, body);
const getType = body => post("getType", {}, body);
const getRecentlyViewedStyles = (body, headers) =>
  post("recentlyViewedStyles", headers, body);
const inThisLook = body => post("multipleStyles", {}, body);
const similarProducts = body => post("similarStyles", {}, body);
const getSizeCharts = sizeChartId => get("sizeCharts", {}, sizeChartId);
const urlShortener = body => post("urlShortener", {}, body);

export {
  urlShortener,
  similarProducts,
  inThisLook,
  getRecentlyViewedStyles,
  getType,
  allProductData,
  getDetails,
  omniFiltersData,
  listingDetails,
  getShippingDetails,
  getSizeCharts,
};



// WEBPACK FOOTER //
// ./src/stores/ProductStore/services.js